import React from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';

import ColorWrapper from '@styles/colors';
import TouchableElement from '@components/common/touchableElement';

import { fontOP } from '@styles/fonts';
import { scaleOP } from '@components/frame';
import { ColorFunction } from '@styles/colors/types';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { SmallLoading } from '@components/loading';

interface ISaveNoteButtonProps {
  C: ColorFunction;
  onSubmit: () => void;
  scale?: ScaleFunction;
  font?: typeof fontOP;
  isAdding?: boolean;
}

const SaveNoteButton: React.FC<ISaveNoteButtonProps> = ({ onSubmit, C, isAdding, scale = scaleOP, font = fontOP }) => {
  return (
    <TouchableElement disabled={isAdding} onPress={onSubmit}>
      {({ boxStyle, pressHoverColor }) => {
        return (
          <View
            style={[
              boxStyle,
              {
                paddingHorizontal: scale(13),
                paddingVertical: scale(6.5),
                backgroundColor: isAdding ? C('Button/Light/Disabled') : C(pressHoverColor('Button/Light/Primary')),
                borderRadius: scale(14.5),
              },
            ]}
          >
            <Text style={[font['Button 2'], { color: isAdding ? C('Label/Light/Quinary') : C('Label/Light/Selected') }]}>{i18n.t(!isAdding ? 'Done' : 'Processing...')}</Text>
          </View>
        );
      }}
    </TouchableElement>
  );
};

export default ColorWrapper(SaveNoteButton);
